import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M2.00062 6.17575V6.63875C1.96262 9.61575 4.02062 15.8158 8.93362 16.9487C13.8466 15.8158 15.9046 9.61575 15.8666 6.65175V6.17575C14.3366 5.79575 11.0426 4.76575 8.93362 2.55975C6.82462 4.76575 3.53162 5.79575 2.00062 6.17575ZM8.93362 18.9718C8.86762 18.9718 8.80262 18.9657 8.73762 18.9527C2.46962 17.6987 -0.0453812 10.3057 0.000618819 6.62575V5.37175C0.000618819 4.88775 0.348619 4.47275 0.825619 4.38775C0.878619 4.37775 6.10362 3.41475 8.10162 0.41775C8.47262 -0.13925 9.39462 -0.13925 9.76562 0.41775C11.7716 3.42675 16.9876 4.37775 17.0406 4.38675C17.5186 4.47175 17.8666 4.88675 17.8666 5.37175V6.63875C17.9136 10.3057 15.3976 17.6987 9.12962 18.9527C9.06462 18.9657 8.99962 18.9718 8.93362 18.9718Z",
];

export function HelpSecurityIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
